import React from 'react';

function Controls(props) {
    const {
        isFullScreen,
        progress,
        playing,
        totalTime,
        remainingTime,
        changePlaybackTime,
        playPreviousTrack,
        playPauseToggle,
        playNextTrack,
        isMobile
    } = props

    return (
        <div className={`
            ${(isFullScreen && isMobile) && '!basis-auto w-full'} ${isFullScreen && 'w-full'} basis-2/4               
        `}>
            <div className='flex flex-col'>
                <div className={`
                    ${(isFullScreen && isMobile) && '!block mb-2' } 
                        hidden md:block
                    `}>
                    <div className="progress-bar">
                        <div className="progress" style={{width: `10%`}}></div>
                    </div>
                    <input
                        type="range"
                        dir='ltr'
                        className='w-full'
                        style={{backgroundSize: `${progress}% 100%`}}
                        min={0}
                        max={100}
                        step={0.01}
                        value={progress}
                        onChange={(e) => changePlaybackTime(parseFloat(e.target.value))}
                    />
                </div>
                <div className={`
                        ${(isFullScreen && isMobile) && 'justify-between'} 
                        ${(isFullScreen && !isMobile) && '!text-sm mt-4'} 
                        flex flex-row justify-center md:justify-between text-xs
                    `}>
                    <span className={`${(isFullScreen && isMobile) && '!block'} hidden md:block`}>{totalTime}</span>
                    <div className="flex flex-row justify-center space-x-1 space-x-reverse">
                        <button onClick={playPreviousTrack}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 strokeWidth={1.5}
                                 stroke="currentColor"
                                 className={`${(isFullScreen && !isMobile) && '!w-10 !h-10'} w-5 h-5`}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M3 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062A1.125 1.125 0 013 16.81V8.688zM12.75 8.688c0-.864.933-1.405 1.683-.977l7.108 4.062a1.125 1.125 0 010 1.953l-7.108 4.062a1.125 1.125 0 01-1.683-.977V8.688z"/>
                            </svg>
                        </button>
                        <button
                            onClick={playPauseToggle}
                            className={`${(isFullScreen && !isMobile) && '!w-[35px]'} w-[20px]`}
                        >
                            {
                                playing
                                    ? <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                           strokeWidth={1.5} stroke="currentColor"
                                           className={`${(isFullScreen && !isMobile) && '!w-10 !h-10'} w-5 h-5`}
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M15.75 5.25v13.5m-7.5-13.5v13.5"/>
                                    </svg>

                                    : <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                           strokeWidth={1.5} stroke="currentColor"
                                           className={`${(isFullScreen && !isMobile) && '!w-10 !h-10'} w-5 h-5`}
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round"
                                              d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"/>
                                    </svg>
                            }
                        </button>
                        <button onClick={playNextTrack}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                 strokeWidth={1.5}
                                 stroke="currentColor"
                                 className={`${(isFullScreen && !isMobile) && '!w-10 !h-10'} w-5 h-5`}
                            >
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M21 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953l7.108-4.062A1.125 1.125 0 0121 8.688v8.123zM11.25 16.811c0 .864-.933 1.405-1.683.977l-7.108-4.062a1.125 1.125 0 010-1.953L9.567 7.71a1.125 1.125 0 011.683.977v8.123z"/>
                            </svg>
                        </button>
                    </div>
                    <span className={`${(isFullScreen && isMobile) && '!block'} hidden md:block`}>{remainingTime} -</span>
                </div>
            </div>
        </div>
    );
}

export default Controls;